// CollectionPage.jsx
import React from "react";
import { useParams, useLocation } from "react-router-dom";
import ProductFilters from "./productFilters.jsx"; // Ensure correct casing: ProductFilters.tsx
import productsData from "./productsData";
import Navbar from "../navbar";
import Footer from "../footer";

const CollectionPage = () => {
  const { category } = useParams(); // e.g., 'sofas', 'all'
  const { pathname } = useLocation();

  // Extract the parent path (e.g., 'livingroom', 'restaurant')
  // Handle both 'living-room' and 'livingroom' formats
  let parentPath = pathname.split("/")[1]?.toLowerCase();
  if (parentPath === 'living-room') {
    parentPath = 'livingroom';
  }

  // Category mappings for better readability and matching product.category
  // Keys should be URL slugs (lowercase), values should be actual product.category values
  const categoryMaps = {
    livingroom: {
      sofas: "Sofas",
      chairs: "Chairs",
      armchairs: "Armchairs",
      "coffee-tables": "Coffee Tables",
      "media-units": "Media Units",
      all: "", // Empty string means "no category filter"
    },
    restaurant: {
      "fine-dining-chairs": "Dining Chairs",
      "dining-chairs": "Restaurant Chairs",
      "dining-tables": "Dining Tables",
      "restaurant-tables": "Restaurant Tables",
      "lounge-furniture": "Lounge Furniture",
      "restaurant-booths": "Restaurant Booths",
      "outdoor-seating": "Outdoor Seating",
      all: "",
    },
    bar: {
      stools: "Bar Stools",
      "bar-stools": "Bar Stools",
      counters: "Bar Counters",
      "bar-counters": "Bar Counters",
      "bar-cabinets": "Bar Cabinets",
      cabinets: "Bar Cabinets",
      "storage-display": "Storage & Display",
      "bar-chairs": "Bar Chairs",
      all: "",
    },
    cafe: {
      tables: "Cafe Tables",
      "cafe-tables": "Cafe Tables",
      chairs: "Cafe Chairs",
      "cafe-chairs": "Cafe Chairs",
      seating: "Cafe",
      outdoor: "Outdoor",
      all: "",
    },
    bedroom: {
      bed: "Bed",
      beds: "Bed",
      wardrobe: "Wardrobe",
      wardrobes: "Wardrobe",
      nightstand: "Nightstand",
      nightstands: "Nightstand",
      dresser: "Dresser",
      dressers: "Dresser",
      all: "",
    },
  };

  // Map the URL section slug to a display title
  const sectionMap = {
    livingroom: "Living Room",
    restaurant: "Restaurant",
    bar: "Bar",
    cafe: "Cafe",
    bedroom: "Bedroom",
  };

  // Determine the category to pass to ProductFilters
  // If `category` is "all" or not found in `categoryMaps`, `selectedCategory` will be "" (no category filter)
  const selectedCategory = categoryMaps[parentPath]?.[category] || ""; // Use empty string for "All"

  // Get the display title for the section
  const sectionTitle = sectionMap[parentPath] || "Collection";

  // IMPORTANT: Filter products by 'section' HERE before passing to ProductFilters
  // This ensures ProductFilters only deals with products relevant to the current URL section.
  const productsForSection = productsData.filter(
    (product) => product.section?.toLowerCase() === parentPath
  );

  return (
    <>
      <div className="p-6 max-w-7xl mx-auto min-h-screen">
        <h1 className="text-3xl font-bold mb-6">
          {sectionTitle} {selectedCategory ? `– ${selectedCategory}` : 'Collection'}
        </h1>
        {/* Pass the already section-filtered products to ProductFilters */}
        <ProductFilters products={productsForSection} initialCategory={selectedCategory} />
      </div>
    </>
  );
};

export default CollectionPage;